import React from 'react'

import { Row, Box } from 'components/_new/layout'
import { ProductImage } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'
import ProductCardHeadline from 'components/_new/product/ProductCardHeadline/ProductCardHeadline'

import s from './ProductListCardBase.scss'


export type ProductListCardBaseProps = {
  image: string
  brand: string | ReactIntlMessage
  name: string | ReactIntlMessage
  label?: string | ReactIntlMessage
  beforeNode?: React.ReactElement
  rightNode?: React.ReactElement
  afterHeadlineNode?: React.ReactElement
  bottomNode?: React.ReactElement
}

const ProductListCardBase: React.FunctionComponent<ProductListCardBaseProps> = (props) => {
  // hope "className" will never be added here!
  const { image, name, brand, label, beforeNode, rightNode, afterHeadlineNode, bottomNode } = props

  return (
    <Row className={s.productListCard} align="stretch" dataTestId="productCard">
      {beforeNode}
      <Box mr={16} relative>
        <ProductImage
          className={s.image}
          src={image}
          resizeBy="height"
          height={100}
          alt={`${brand} ${name}`}
          dataTestId="productCardImage"
        />
        {
          Boolean(label) && (
            <Text className={s.label} message={label} size="12-16" color="white" uppercase letterSpacing />
          )
        }
      </Box>
      <div className={s.content}>
        <Row className={s.mainContent} align="start">
          <div className={s.mainContentLeftNode}>
            <ProductCardHeadline
              brand={brand}
              name={name}
            />
            {
              afterHeadlineNode && (
                <Box mt={16}>
                  {afterHeadlineNode}
                </Box>
              )
            }
          </div>
          {
            rightNode && (
              <Box ml={16}>
                {rightNode}
              </Box>
            )
          }
        </Row>
        {
          bottomNode && (
            <Box mt={16}>
              {bottomNode}
            </Box>
          )
        }
      </div>
    </Row>
  )
}


export default ProductListCardBase
